import React, { useEffect, useMemo, useState } from "react";
import { Autocomplete } from "@material-ui/lab";
import { CssTextField } from "../styles/StyledComponents";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { Checkbox, Chip, CircularProgress } from "@mui/material";
import { primary } from "../styles/colors";


const MenuProps = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left",
  },
  getContentAnchorEl: null,
  PaperProps: {
    style: {
      maxHeight: 200, // Set the maximum height for the dropdown
    },
  },
  MenuListProps: {
    style: {
      overflowY: "auto", // Enable vertical scrolling
    },
  },
};

const getNestedValue = (obj, key) => {
  return key
    .split(".")
    .reduce((acc, curr) => (acc[curr] ? acc[curr] : ""), obj);
};

const MultiLineRender = ({ option, optionKeys }) => {
  console.log(option, optionKeys);
  return (
    <li
      style={{
        display: "flex",
        flexDirection: "column",
        lineHeight: "1em",
        fontFamily: "Poppins",
        width: '100%'
      }}
    >
      {optionKeys.map((item, index) => {
        return (
          <div
            key={index}
            style={{
              fontSize: index === 0 ? "14px" : "10px",
              color: index === 0 ? "#333" : "grey",
              marginbottom: index === 0 ? "2px" : "0px",
              width: '100%',
              display: "flex",
              justifyContent: 'space-between'
            }}
          >
            <span>
              <span style={{ fontWeight: 500, fontSize: 12 }}>{item?.label || ""} </span>
              <span style={{ fontSize: 12}}>
                {item?.key?.includes(".")
                  ? getNestedValue(option, item?.key)
                  : option?.[item?.key] || ""}
                {item?.key2?.includes(".")
                  ? getNestedValue(option, item?.key2)
                  : option?.[item?.key2] || ""}
              </span>
            </span>
              {item?.keyB && (
                <span>
                  <span style={{ fontWeight: 500, fontSize: 11,textAlign:'right' }}>{item?.labelB || ""} </span>
                  <span style={{ fontSize: 11, textAlign:'right'}}>
                    {item?.keyB?.includes(".")
                      ? getNestedValue(option, item?.keyB)
                      : option?.[item?.keyB] || ""}
                    {item?.keyB2?.includes(".")
                      ? getNestedValue(option, item?.keyB2)
                      : option?.[item?.keyB2] || ""}
                  </span>
                </span>
              )}
          </div>
        );
      })}
    </li>
  );
};

export const CustomAutocomplete = (props) => {
  // console.log("VALUE-AUTO",props.value)
  return (
    <Autocomplete
      {...props}
      value={props?.value || null}
      onChange={(e, newValue) => {
        if (props?.onChange) {
          props?.onChange(e, newValue);
        }
      }}
      options={[...(Array.isArray(props?.options) ? props.options : [])].sort((a, b) =>
        (a[props.sortKey || "name"] || "").localeCompare(
          b[props.sortKey || "name"] || ""
        )
      )}
      getOptionLabel={(option) =>
        props?.getOptionLabel(option) || option?.title || ""
      }
      MenuProps={MenuProps}
      renderOption={(option, p) => {
        const optionLabel = props?.getOptionLabel(option);
        if (props.renderOption) {
          return props.renderOption(option, p);
        } else if (props.multiLineRender?.length) {
          return (
            <MultiLineRender
              option={option}
              optionKeys={props.multiLineRender}
            />
          );
        } else {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                lineHeight: "1.1em",
                fontFamily: "Poppins",
                fontSize: "0.9rem",
                margin: "5px 0",
              }}
            >
              <span>{optionLabel || ""}</span>
            </div>
          );
        }
      }}
      renderInput={(params) => (
        <CssTextField
          {...params}
          label={props?.label || ""}
          variant="outlined"
          required={props?.required || false}
          helperText={props?.helperText}
          error={props?.error}
          onBlur={props?.onBlur}
          inputProps={{
            ...params.inputProps,
            style: {
              padding: "10px 6px",
              fontSize:  "0.9rem",
            },
          }}
          // InputProps={{
          //   ...params.InputProps,
          //   endAdornment: (
          //     <>
          //       {Boolean(props?.OptionLoader) ? (
          //         <CircularProgress color="inherit" size={20} />
          //       ) : null}
          //       {params.InputProps.endAdornment}
          //     </>
          //   ),
          // }}
        />
      )}
      // style={{
      //   width: props.width || 200,
      //   ...(props?.style || {}),
      // }}
    />
  );
};

export const CustomMultiSelectAutocomplete = (props) => {
  const icon = (
    <CheckBoxOutlineBlankIcon fontSize="small" style={{ color: primary }} />
  );
  const checkedIcon = (
    <CheckBoxIcon fontSize="small" style={{ color: primary }} />
  );

  return (
    <Autocomplete
      {...props}
      multiple
      id="checkboxes-tags-demo"
      value={props?.value || []}
      onChange={(e, newValue) => {
        const updatedValue = props.value.some((item) => item.id === newValue[newValue.length - 1]?.id)
          ? props.value.filter((item) => item.id !== newValue[newValue.length - 1].id) // Remove if exists
          : [...props.value, newValue[newValue.length - 1]]; // Add if not exists
        console.log(updatedValue);
        props?.onChange?.(e, updatedValue);
      }}
      MenuProps={MenuProps}
      options={props?.options || []}
      getOptionLabel={(option) =>
        props?.getOptionLabel(option) || option?.title || ""
      }
      disableCloseOnSelect
      renderOption={(p, option, state) => {
        const { key, ...optionProps } = p;
        if (!option) return null;
        return (
          <li key={key} {...optionProps} className="d-flex alignC">
            {console.log(p,props?.optionKey, p[props?.optionKey], option, state, props.value)}
            <div>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8, padding: 0, color: primary }}
                checked={Boolean(
                  props?.value?.length > 0 &&
                    props.value.some((s) => s.id == p.id)
                )}
              />
            </div>
            <div style={{ fontSize:  "0.8rem" }}>
              {p[props?.optionKey] || ""}
            </div>
          </li>
        );
      }}
      renderTags={(value, getTagProps) => {
        return value && value.length > 0 && typeof value !== "string"
          ? value.map((option, index) => (
              <>
                {console.log(
                  option,
                  props?.optionKey,
                  option[props?.optionKey]
                )}
                <Chip
                  key={value.toString()}
                  variant="outlined"
                  label={option[props?.optionKey]}
                  size="small"
                  style={{
                    fontFamily: "Poppins",
                    padding: "0 5px",
                    margin: "2px",
                  }}
                  {...getTagProps({ index })}
                  disabled={props?.fixedOptions?.includes(option?.id)}
                />
              </>
            ))
          : "";
      }}
      style={{
        width: props.width || 200,
        ...(props?.style || {}),
      }}
      renderInput={(params) => (
        <CssTextField
          {...params}
          label={props?.label || ""}
          variant="outlined"
          required={props?.required || false}
          helperText={props?.helperText}
          error={props?.error}
          onBlur={props?.onBlur}
          inputProps={{
            ...params.inputProps,
            style: {
              padding: "6px",
              fontSize: "0.9rem",
            },
          }}
        />
      )}
    />
  );
};

